import { render, staticRenderFns } from "./Breakouts.vue?vue&type=template&id=f21630f6&"
import script from "./Breakouts.vue?vue&type=script&lang=js&"
export * from "./Breakouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f21630f6')) {
      api.createRecord('f21630f6', component.options)
    } else {
      api.reload('f21630f6', component.options)
    }
    module.hot.accept("./Breakouts.vue?vue&type=template&id=f21630f6&", function () {
      api.rerender('f21630f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/asset/Breakouts.vue"
export default component.exports